import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import DocumentListPageUI from './DocumentListPageUI.js'
import { withRouter } from 'react-router-dom'

class DocumentListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loanList: null,

    }
  }

  render() {
    return (
      <DocumentListPageUI
        context={this.props.context}
        account={this.state.account}
        errorList={this.state.errorList}
        loanList={this.state.loanList}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getLoans(context)
  }

  getLoans(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/loans`,
      cacheKey: CacheKeys.AccountLoans(this.props.match.params.accountId),
      callback: this.getLoansCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoansCallback = (response) => {
    this.setState({ errorList: response.errorList, loanList: response.loanList })
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

 onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.RiskRegisters(this.state.year, this.state.month))
    if (noBusy === 'noBusy') {
      this.getRiskRegisters(context, this.state.year, this.state.month)
    }
    else
      this.setState({ riskRegisterList: null, errorList: null },
        this.getRiskRegisters(context, this.state.year, this.state.month)
      )
  }
}

export default withRouter(DocumentListPageSF) 
